import React, {useState,useEffect,useContext} from "react";
import Lang from '../lang/translations';
import { Link, useNavigate } from 'react-router-dom';
import Context from '../context/context';
import ReactGA from 'react-ga4';
import FormHomepage from '../form/formHomepage'
const config = require("../_helpers/configServizi"); 


export default function Signup(props) {

   

    const domain = window.location.hostname;
   	const url_logo = config.servizi[domain].logo_su_scuro;


    useEffect(() => { 
        //ReactGA.pageview('/homepage', "Homepage")
	},[]);
    
   

    return (<div>
                <nav>
                    <div className="navbar navbar-default navbar-fixed-top" role="navigation">
                        <div className="container">
                                <div className="navbar-header">
                                    <Link className="navbar-brand" to="/"><img src={url_logo} className="img-fluid" /></Link>
                                </div>
                               

                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                            </div>
                        </div>
                    </div>
                </nav>

                <nav className="navbar navbar-expand-lg navbar-light fixed-top d-none d-lg-block ">
                    <div className="container navbar-desktop">
                        <Link className="navbar-brand" to="/"><img src={url_logo} className="img-fluid" /></Link>
                        <div className="navbar-collapse" id="navbarSupportedContent">
                    
                        
                        </div>{}
                    </div>
                </nav>

                <section className="page-section personal-container" id="services">
                    <div className="all-container bg-light padding_top">
                        <div className="container filters-no-padding" role="main">
                        <div className="row">
                            <div className="col-md-7 col-12 col-centered">
                                <FormHomepage/>
                            </div>
                        </div>
                        </div>
                    </div>
                </section>

                <div className="footer d-lg-block">
        <div className="container mb-0">
        <div className="mb-0">
             {config.servizi[domain].legal_link.faq.startsWith("https://") &&
             
             <nav>
                    <Link target="_blank" to={config.servizi[domain].legal_link.faq}><Lang w={"faq"} page={"footer"}/></Link>
                    <Link target="_blank" to={config.servizi[domain].legal_link.termini}><Lang w={"termini"} page={"footer"}/></Link>
                    <Link target="_blank" to={config.servizi[domain].legal_link.privacy}><Lang w={"privacy"} page={"footer"}/></Link>
                    <Link target="_blank" to={config.servizi[domain].legal_link.cookie}><Lang w={"cookie"} page={"footer"}/></Link>
                    <Link target="_blank" to={config.servizi[domain].legal_link.contatti}><Lang w={"contact_us"} page={"footer"}/></Link>
                </nav>
            }
        </div>
        <img className="creditCardFlags" src="/img/credit-card-icons.png" border="0" />
        <p className="font-08 mb-0">{config.servizi[domain].title} &copy; - {config.servizi[domain].anno} </p>
    </div>

   

    </div>
               
        </div>)

}
